import classNames from "classnames";
import PropTypes from "prop-types";
import "./RadioIcon.scss";

const RadioChecked = ({ className, size = 16, stroke = "currentColor", ...props }) => {
	const radioCheckedClassName = classNames("radio-checked-icon", {
		[className]: className,
	});

	return (
		<svg
			className={radioCheckedClassName}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<circle cx="8" cy="8" r="7.5" stroke={stroke} />
			<circle cx="8" cy="8.00002" r="4.57143" fill={stroke} />
		</svg>
	);
};

RadioChecked.propTypes = {
	stroke: PropTypes.string,
	size: PropTypes.number,
};

const RadioUnchecked = ({ className, size = 16, stroke = "currentColor", ...props }) => {
	const radioUncheckedClassName = classNames("radio-unchecked-icon", {
		[className]: className,
	});

	return (
		<svg
			className={radioUncheckedClassName}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			{...props}
		>
			<circle cx="8" cy="8" r="7.5" stroke={stroke} />
		</svg>
	);
};

RadioUnchecked.propTypes = {
	stroke: PropTypes.string,
	size: PropTypes.number,
};

export const RadioIcon = ({ checked, className, size = 16, stroke = "currentColor", ...props }) => {
	const radioClassName = classNames("radio-icon", {
		[className]: className,
	});
	return checked ? (
		<RadioChecked className={radioClassName} size={size} stroke={stroke} {...props} />
	) : (
		<RadioUnchecked className={radioClassName} size={size} stroke={stroke} {...props} />
	);
};

RadioIcon.propTypes = {
	checked: PropTypes.bool.isRequired,
	size: PropTypes.number,
	stroke: PropTypes.string,
};
